import { render } from "./Icons.vue?vue&type=template&id=0f0261bd"
import script from "./Icons.vue?vue&type=script&lang=ts"
export * from "./Icons.vue?vue&type=script&lang=ts"
script.render = render

export default script